<template>
  <div>
    <div class="card container my-3 my-md-5">
      <div class="card-body" ref="pdfContent">
        <div class="row justify-content-around">
          <div class="element-to-hide col" data-html2canvas-ignore="true">
            <b-form-select size="sm" v-model="selectedCarrier" :options="carriers" :disabled="queryInProgres"></b-form-select>
          </div>
          <h4 class="card-title text-center col-8">{{title}}</h4>
          <div class="col" data-html2canvas-ignore="true"></div>
        </div>
        <b-table :items="shipments" small tdClass="p-0" :fields="fields" :bordered="true" id="test">
        </b-table>
        Anzahl Sendungen: {{ shipments.length }}
        <div class="mt-4">
          Ich bestätige die angegebenen Sendungen entgegengenommen zu haben.<br>
          <div class="mt-4">_________________<br>
          <small>{{workerSignature}}</small></div>
        </div>
      </div>
      <div class="d-flex justify-content-between mt-5">
        <div v-if="isDhlExpress" class="d-flex ml-4 mb-2">
          <label for="pickupDate" class="my-auto mr-3 text-nowrap">Nächstes Abholdatum: </label>
          <b-input-group class="">
            <b-form-input
              id="pickupDate"
              v-model="formattedPickupDate"
              type="text"
              placeholder=""
              autocomplete="off"
              disabled
            ></b-form-input>
            <b-input-group-append>
              <b-form-datepicker
                v-model="pickupDate"
                button-only
                right
                start-weekday="1"
                aria-controls="example-input"
              ></b-form-datepicker>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="ml-auto">
          <b-btn variant="success" class="mb-2 mr-3 ml-auto" @click="generateExcelFile(mappedShipments, selectedCarrierName+'_Versandliste')" :disabled="queryInProgres || generateFileInProgress">Excel Export
              <b-spinner v-if="generateFileInProgress" variant="light" small></b-spinner>
          </b-btn>        
          <b-btn variant="primary" class="mb-2 mr-3 ml-auto" @click="createDailyClosing" :disabled="queryInProgres || generateFileInProgress">Abschluss erstellen
              <b-spinner v-if="queryInProgres" variant="light" small></b-spinner>
          </b-btn>
        </div>
      </div>
    </div>
    <b-modal v-model="modalError.state" size="md" centered dismissible>{{modalError.message}}</b-modal>
  </div>
</template>
<script>
import html2pdf from 'html2pdf.js'
import moment from 'moment';

export default {
  props: ['passedCarriers'],
  data(){
    return {
      fields: [
        { key: "shippingId",    label: "Sendungsnummer" },
        { key: "name",          label: "Empfänger" },
        { key: "marketOrderId", label: "MarketOrderId" }
      ],
      carriers: [],
      shipments: [],
      pickupDate: null,
      selectedCarrier : -1,
      rangeStart: null,
      queryInProgres: false,
      generateFileInProgress: false,
      modalError: {
        state: false,
        message: ""
      },
    }
  },
  computed:{
    selectedCarrierName(){
      if(this.selectedCarrier === -1) return
      else return this.carriers.find(element => element.value === this.selectedCarrier).text;
    },
    title(){
      if(this.selectedCarrier === -1) return 'Tagesabschluss'
      else {
        return this.selectedCarrierName + ' Tagesabschluss ' + moment().format("DD.MM.YYYY");
      }
    },
    workerSignature(){
      if(this.selectedCarrier === -1) return 'Mitarbeiter'
      return this.selectedCarrierName + ' Mitarbeiter';
    },
    isDhlExpress(){
      return this.selectedCarrier == 1;
    },
    formattedPickupDate(){
      if(this.pickupDate === null) return;
      return moment(this.pickupDate, "YYYY-MM-DD").format('DD.MM.YYYY');
    },
    mappedShipments(){
      return this.shipments.map(shipment => {
        return {
          Sendungsnummer : shipment.shippingId,
          Empfänger : shipment.name,
          MarketOrderId : shipment.marketOrderId
        }
      })
    }
  },
  watch:{
    selectedCarrier(){
      if(!this.queryInProgres) this.fetchShipments();
    }
  },
  methods:{
    createDailyClosing(){
      if(this.selectedCarrier === -1) return;
      if(this.pickupDate === null && this.selectedCarrier == 1){
        alert('Abholdatum bitte angeben');
        return;
      }

      if(this.selectedCarrier != 1){
        this.pickupDate = null;
      }

      let request = {
        carrierId: this.selectedCarrier,
        pickupDate: this.pickupDate,
      }

      axios.post('/shipping_service_pickup', request).
      then(res => {
        console.log(res);
        this.generatePDF();
      })
      .catch(err => {
        console.log(err);
        if(err.response.data !== "" || err.response.data !== null){
          this.modalError = {
            state: true,
            message: "Ein Fehler is aufgetreten: " + JSON.stringify(err.response.data.message)
          }
        } else {
          this.modalError = {
            state: true,
            message: "Ein Fehler is aufgetreten: " + JSON.stringify(err.message)
          }
        }
      })
    },
    fetchShipments(){
      this.queryInProgres = true;
      axios.get('shipping_service_pickup/'+this.selectedCarrier)
      .then(response => {
        console.log(response);
        this.queryInProgres = false;
        this.shipments = response.data;
      })
      .catch(err => {
        console.log(err);
        this.queryInProgres = false;
        if(err.response.data !== "" || err.response.data !== null){
          this.modalError = {
            state: true,
            message: "Ein Fehler is aufgetreten: " + JSON.stringify(err.response.data.message)
          }
        } else {
          this.modalError = {
            state: true,
            message: "Ein Fehler is aufgetreten: " + JSON.stringify(err.message)
          }
        }
      });
    },

    generatePDF(){
      let currentDate = moment().format("DD.MM.YYYY");
      let pdfOptions = {
        margin: 7,
        filename: this.selectedCarrierName+'_Versandliste-'+currentDate+'.pdf',
        html2canvas: { orientation: 'potrait'},
        pagebreak: {mode: 'css' },
      };
      this.printToggle = true;
      const pdfInstance =  html2pdf().from(this.$refs.pdfContent).set(pdfOptions).outputPdf();
      pdfInstance.save();
      
    },
      generateExcelFile(mappedData, fileName){
      this.generateFileInProgress = true;
      let currentDate = moment().format("DD.MM.YYYY");
        Vue.nextTick().then(() => {
            const ws = XLSX.utils.json_to_sheet(mappedData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws);
            XLSX.writeFile(wb, fileName +'-'+ currentDate + ".xlsx");
            this.generateFileInProgress = false;
        })
      },
  },
  mounted(){
    this.carriers = this.passedCarriers.map(element => { return { value: element.id, text: element.name}});
    this.carriers.unshift({value : -1, text: "---Anbieter--", disabled: true});
  },
  created(){
  }
}
</script>
<style>
tr {
  page-break-after: auto!important;
  page-break-inside: avoid!important;
    
}
.table-sm td  {
  padding: 0.1rem !important;
  padding-left: 0.3rem !important;
}
</style>